import { useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { OBJECTLESS_WORKFLOWS } from 'automation-ui-canvas/constants/Gates';
import TriggerSelectionPanel from 'automation-ui-canvas/create/TriggerSelectionPanel';
import PropertySelectionPanel from 'automation-ui-canvas/create/trigger-prompts/PropertySelectionPanel';
import ListMembershipTypeSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/ListMembershipTypeSelectionPanel';
import ListSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/ListSelectionPanel';
import ObjectTypeSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/ObjectTypeSelectionPanel';
import PropertyObjectTypeSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/PropertyObjectTypeSelectionPanel';
import FormSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/FormSelectionPanel';
import WorkflowSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/WorkflowSelectionPanel';
import WebhookSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/WebhookSelectionPanel';
import { getListMembershipEventName } from 'automation-ui-enrollment/utils/listMembershipUtils';
import { useTriggerOptions } from 'automation-ui-canvas/create/hooks/useTriggerOptions';
import CreateStepIndicator from 'automation-ui-canvas/create/CreateStepIndicator';
import { GET_CUSTOM_WORKFLOW_PROPERTIES } from 'automation-ui-canvas/queries/workflowFormCreatorQueries';
import { getSteps } from 'automation-ui-canvas/create/steps/utils/getSteps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CUSTOM_PANEL_FOR_EVENT_FQN = new Map([['e_property_value_changed', [PropertyObjectTypeSelectionPanel, PropertySelectionPanel]], [getListMembershipEventName(), [ListMembershipTypeSelectionPanel, ListSelectionPanel]], ['e_object_created_v2', [ObjectTypeSelectionPanel]], ['e_form_submission_v2', [FormSelectionPanel]], ['e_form_interaction_v2', [FormSelectionPanel]], ['e_form_view_v2', [FormSelectionPanel]], ['e_workflow_enrolled_v2', [WorkflowSelectionPanel]], ['e_workflow_unenrolled_v2', [WorkflowSelectionPanel]], ['e_workflow_goal_v2', [WorkflowSelectionPanel]]]);
export default function TriggerType({
  onSelectTriggerOption,
  objectTypeId,
  setObjectTypeId,
  stagedTriggerOption,
  setStagedTriggerOption
}) {
  var _workflowPropertiesDa;
  const [PanelComponent, setPanelComponent] = useState(null);
  const {
    loading,
    triggerOptions,
    webhookTriggerOptions
  } = useTriggerOptions();
  const isUngatedForObjectlessWorkflows = useIsUngated(OBJECTLESS_WORKFLOWS);
  const {
    data: workflowPropertiesData
  } = useQuery(GET_CUSTOM_WORKFLOW_PROPERTIES);
  const workflowProperties = (_workflowPropertiesDa = workflowPropertiesData === null || workflowPropertiesData === void 0 ? void 0 : workflowPropertiesData.customWorkflowProperties) !== null && _workflowPropertiesDa !== void 0 ? _workflowPropertiesDa : [];
  const hasCustomProperties = workflowProperties.length > 0;
  const handleSelectTriggerOption = newTriggerOption => {
    if (newTriggerOption.type === 'EVENT') {
      var _CUSTOM_PANEL_FOR_EVE;
      const defaultCustomPanels = newTriggerOption.supportedObjectTypeIds.length === 0 ? [ObjectTypeSelectionPanel] : [];
      const customPanels = (_CUSTOM_PANEL_FOR_EVE = CUSTOM_PANEL_FOR_EVENT_FQN.get(newTriggerOption.fullyQualifiedName)) !== null && _CUSTOM_PANEL_FOR_EVE !== void 0 ? _CUSTOM_PANEL_FOR_EVE : defaultCustomPanels;
      const currentPanelIndex = customPanels.indexOf(PanelComponent);
      const customPanel = customPanels[currentPanelIndex + 1];
      if (customPanel) {
        setStagedTriggerOption(newTriggerOption);
        setPanelComponent(() => customPanel);
        return;
      }
    } else if (newTriggerOption.type === 'WEBHOOK') {
      setStagedTriggerOption(newTriggerOption);
      return;
    }
    onSelectTriggerOption(newTriggerOption);
  };
  let panelContent = null;
  if ((stagedTriggerOption === null || stagedTriggerOption === void 0 ? void 0 : stagedTriggerOption.type) === 'EVENT' && PanelComponent) {
    panelContent = /*#__PURE__*/_jsx(PanelComponent, {
      objectTypeId: objectTypeId,
      setObjectTypeId: setObjectTypeId,
      onClose: () => {
        setStagedTriggerOption(null);
        setObjectTypeId(UNKNOWN_ID);
        setPanelComponent(null);
      },
      stagedTriggerOption: stagedTriggerOption,
      onSelectTriggerOption: handleSelectTriggerOption
    });
  } else if ((stagedTriggerOption === null || stagedTriggerOption === void 0 ? void 0 : stagedTriggerOption.type) === 'WEBHOOK') {
    panelContent = /*#__PURE__*/_jsx(WebhookSelectionPanel, {
      webhookTriggerOptions: webhookTriggerOptions,
      onSelectTriggerOption: onSelectTriggerOption
    });
  }
  if (stagedTriggerOption && panelContent) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: 0,
        children: /*#__PURE__*/_jsx(CreateStepIndicator, {
          stepIndex: 0,
          steps: getSteps({
            selectedTriggerOption: stagedTriggerOption,
            objectTypeId,
            isUngatedForObjectlessWorkflows,
            hasCustomProperties
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        minBlockSize: "0",
        children: panelContent
      })]
    });
  }
  return /*#__PURE__*/_jsx(TriggerSelectionPanel, {
    triggerOptions: triggerOptions,
    triggerOptionsLoading: loading,
    onSelectTriggerOption: handleSelectTriggerOption
  });
}